import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.16689 11.0836C8.16689 10.1553 7.79815 9.26506 7.14177 8.60869C6.48539 7.95231 5.59515 7.58356 4.66689 7.58356M4.66689 7.58356C3.73864 7.58356 2.8484 7.95231 2.19202 8.60869C1.53564 9.26506 1.16689 10.1553 1.16689 11.0836M4.66689 7.58356C5.95556 7.58356 7.00023 6.53889 7.00023 5.25023C7.00023 3.96156 5.95556 2.91689 4.66689 2.91689C3.37823 2.91689 2.33356 3.96156 2.33356 5.25023C2.33356 6.53889 3.37823 7.58356 4.66689 7.58356ZM12.8336 11.0836C12.8336 10.1553 12.4648 9.26506 11.8084 8.60869C11.1521 7.95231 10.2618 7.58356 9.33356 7.58356C9.9524 7.58356 10.5459 7.33773 10.9835 6.90014C11.4211 6.46256 11.6669 5.86907 11.6669 5.25023C11.6669 4.63139 11.4211 4.0379 10.9835 3.60031C10.5459 3.16273 9.9524 2.91689 9.33356 2.91689",
      stroke: "#768396",
      "stroke-width": "1.3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }